import React, { useState } from 'react';

/**
 * AnswerForm component renders a form to submit answers in different languages.
 * 
 * @param {Array} languages - The languages to create answers in.
 * @param {function} onSubmit - Function to handle form submission.
 * @param {number} itemID - The ID of the item to associate the answers with. 
 * @returns {JSX.Element} A form element for submitting answers.
 */
export const AnswerForm = ({ languages, onSubmit, itemID }) => {

    /**
     * Handles the form submission event.
     */
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.target);
        onSubmit(data, itemID);
    };

    return (
        <div>
            <form onSubmit={handleSubmit} method="post" className="answer-form">
                <div className="form-group">
                    {languages.map((props) => (
                        <div key={props.id} className="answer-form-section">
                            <label>{props.languageText}</label>

                            <input type="number" name={`answerList[${props.id - 1}].LanguageId`} value={props.id} readOnly style={{ display: "none" }} />
                            <input name={`answerList[${props.id - 1}].AnswerText`} type="text" className="form-control" id="alternativ" placeholder="Vad är alternativet?" />
                            <input name={`answerList[${props.id - 1}].AudioFile`} type="file" className="form-control" id="audioUrl" />
                        </div>
                    ))}
                </div>
                <button type="submit" className="btn btn-primary">Skapa</button>
            </form>
        </div>
    );
};
